module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-25.61b21421.png";